import styled from '@emotion/styled';
import { Button } from '@mui/material';

const ViewReleaseButton = styled(Button)({
  marginLeft: -8,
}) as typeof Button;

export default ViewReleaseButton;
